import commonPostTypeConfig from '../../common/postTypes/age'

export default function initPostType({ wapp }) {
    return wapp.client.postTypes.getPostType({
        name: 'age',
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager()
    })
}
